import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {ArticleModel, ArticleReadingModel, ArticleActivityModel} from '@/libs/Api';
import {ArticlesDataService} from '@/libs/articles/articles-data-service';
import {ArticleReadingsDataService} from '@/libs/articles/article-readings-data-service';
import {ArticleActivitiesDataService} from '@/libs/articles/article-activities-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const articlesStore = registerCrudStore<ArticleModel, ArticleModel>(StoreName.Article, new ArticlesDataService());
export const articleReadingsStore = registerCrudStore<ArticleReadingModel, ArticleReadingModel>(StoreName.ArticleReading, new ArticleReadingsDataService());
export const articleActivitiesStore = registerCrudStore<ArticleActivityModel, ArticleActivityModel>(StoreName.ArticleActivity, new ArticleActivitiesDataService());
